// Feb 2026 — Club Events client.
import axios from 'axios';

const client = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  headers: { 'Content-Type': 'application/json' },
});
client.interceptors.request.use((cfg) => {
  const token = typeof window !== 'undefined' ? localStorage.getItem('tl_session_token') : null;
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

export const clubEventsAPI = {
  list:    (opts = {}) => client.get('/club-events', { params: opts }),
  get:     (id)         => client.get(`/club-events/${id}`),
  create:  (payload)    => client.post('/club-events', payload),
  update:  (id, p)      => client.patch(`/club-events/${id}`, p),
  archive: (id)         => client.post(`/club-events/${id}/archive`),
  restore: (id)         => client.post(`/club-events/${id}/restore`),
  remove:  (id)         => client.delete(`/club-events/${id}`),
  uploadFlyer: (id, file) => client.post(`/club-events/${id}/flyer`, file, {
    headers: { 'Content-Type': file?.type || 'application/octet-stream' },
    transformRequest: [(data) => data],
  }),
  deleteFlyer: (id)     => client.delete(`/club-events/${id}/flyer`),
  // V2 — RSVP endpoints. All go through authenticated API (never Supabase direct).
  rsvp:    (id)         => client.post(`/club-events/${id}/rsvp`),
  unrsvp:  (id)         => client.delete(`/club-events/${id}/rsvp`),
  listRsvps: (id)       => client.get(`/club-events/${id}/rsvps`),
  // V3.1 — admin-only manual paid toggles (backend service-role only).
  markPaid:   (id, profileId) => client.post(`/club-events/${id}/attendees/${profileId}/mark-paid`),
  markUnpaid: (id, profileId) => client.post(`/club-events/${id}/attendees/${profileId}/mark-unpaid`),
};
